/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProfileAlertResponse
 */
export interface AdminProfileAlertResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminProfileAlertResponse
     */
    makeProfileInvisible: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminProfileAlertResponse
     */
    message: string;
}

/**
 * Check if a given object implements the AdminProfileAlertResponse interface.
 */
export function instanceOfAdminProfileAlertResponse(value: object): value is AdminProfileAlertResponse {
    if (!('makeProfileInvisible' in value) || value['makeProfileInvisible'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AdminProfileAlertResponseFromJSON(json: any): AdminProfileAlertResponse {
    return AdminProfileAlertResponseFromJSONTyped(json, false);
}

export function AdminProfileAlertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProfileAlertResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'makeProfileInvisible': json['makeProfileInvisible'],
        'message': json['message'],
    };
}

export function AdminProfileAlertResponseToJSON(value?: AdminProfileAlertResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'makeProfileInvisible': value['makeProfileInvisible'],
        'message': value['message'],
    };
}

